import styled from 'styled-components';
import { sizes, theme } from 'theme';

export type AccordionPanelItemProps = {
    action: () => void;
    aria: string;
    content: JSX.Element;
};

export default function AccordionPanelItem({ action, aria, content }: AccordionPanelItemProps): JSX.Element {
    return (
        <PanelItem onClick={action} aria-label={aria}>
            {content}
        </PanelItem>
    );
}

const PanelItem = styled.button`
    cursor: pointer;
    display: flex;
    gap: ${sizes.spacingRg};
    padding: ${sizes.spacingSm};
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    border: 1px solid transparent;
    border-bottom-color: ${theme.cardBorder};
    border-radius: ${sizes.borderRadiusLg};
    background-color: inherit;

    transition:
        background-color 150ms ease,
        border-color 150ms ease,
        box-shadow 150ms ease;

    &:hover {
        background-color: ${theme.secondaryButtonHoverBackgroundColour};
        border-color: ${theme.secondaryButtonBorderColour};
    }

    &:focus-visible {
        background-color: ${theme.cardNavigation.backgroundFocused};
        border-color: ${theme.cardNavigation.borderFocused};
        outline: none;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`;
